export default __webpack_public_path__ + "static/media/girl_s.45888b15.png";